import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Grid,
  useTheme,
  useMediaQuery,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import jwtDecode from "jwt-decode";
import StaffProfile from "./staffProfile";
import BookingTypeStaffForm from "./bookingTypeStaffForm";
import { useSearchParams } from "react-router-dom";
import { GET_TOKEN } from "../../../graphql/queries";
import WorkingHourView from "../workingHourView";
import { EntityType } from "../../../redux/actions/businessActions";
import CalendarIntegration from "../integeration/calendarIntegration";
import ImageEntryForm from "../image/imageEntryForm";

// Constants

const StaffDetailHorizontalTab = (props) => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab"); // Access the tab query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");

  const tabIndex = code ? 3 : parseInt(tab || "0", 10); // Default to "0" if tab is undefined

  const [selectedIndex, setSelectedIndex] = useState(tabIndex ?? 0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleMenuItemClick = (index) => {
    setSelectedIndex(index);
  };

  const staffData = props.businessStaff;
  const {
    loading: tokenLoading,
    error: tokenError,
    data: tokenData,
    refetch: tokenRefetch,
  } = useQuery(GET_TOKEN, {
    variables: {
      userId: null,
      staffId: Number(staffData?.id),
      subscriptionId: null,
      businessId: null,
    },
  });

  const decodedToken =
    tokenData && tokenData !== "undefined"
      ? jwtDecode(tokenData.getToken.token)
      : null;

  if (tokenLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress disableShrink size={100} />
      </Box>
    );
  }

  const menuItems = [
    { label: "Profile", index: 0 },
    { label: "Working Hour", index: 1 },
    { label: "Assigned Booking Types", index: 2 },
    { label: "Integration", index: 3 },
    { label: "Images", index: 4 },
  ];

  return staffData ? (
    <Grid container spacing={2}>
      {/* Left column for menu */}
      <Grid item xs={12} md={3} sx={{ eight: "auto" }}>
        {isMobile ? (
          // Dropdown for mobile view
          <Box sx={{ mt: 10 }}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Select Staff Detail </InputLabel>
              <Select
                labelId="menu-select-label"
                id="menu-select"
                value={selectedIndex}
                onChange={(e) => handleMenuItemClick(e.target.value)}
                label="Select"
              >
                {menuItems.map((item) => (
                  <MenuItem key={item.index} value={item.index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ) : (
          // List for desktop view
          <Box
            sx={{
              overflowY: "auto",
              maxHeight: "calc(100vh - 100px)", // Adjust height to fit within view if mobile
            }}
          >
            <List>
              {menuItems.map((item) => (
                <ListItem
                  button
                  key={item.index}
                  selected={selectedIndex === item.index}
                  onClick={() => handleMenuItemClick(item.index)}
                >
                  <ListItemText primary={item.label} />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
      </Grid>

      {/* Right column for content */}
      <Grid item xs={12} md={9} sx={{ padding: 2 }}>
        {selectedIndex === 0 && <StaffProfile staff={staffData} />}
        {selectedIndex === 1 && (
          <WorkingHourView
            key={Math.floor(Math.random() * 1000)}
            providerUser={decodedToken}
            workingHourDatas={[]}
            isDisabled={props.isCalenderDisabled}
            entityType={EntityType.STAFF}
            isCustom={false}
            defaultWH={true}
            staffData={staffData}
          />
        )}
        {selectedIndex === 2 && (
          <BookingTypeStaffForm
            staff={staffData}
            isDisabled={props.isBookingTypeDisabled}
          />
        )}
        {selectedIndex === 3 && (
          <CalendarIntegration
            isDisabled={props.isStaffCanEditItsEmailIntegeration}
          />
        )}
        {selectedIndex === 4 && (
          <ImageEntryForm
            singleImageMode={true}
            avatar={true}
            staffId={staffData?.id}
            isDisabled={props.isStaffCanEditItsImage}
          />
        )}
      </Grid>
    </Grid>
  ) : null;
};

export default StaffDetailHorizontalTab;
